import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { adminStats } from "@/lib/api";
import { StorageMeter } from "./StorageMeter";
import { ExternalImages } from "./ExternalImages";

function StatCard({ label, value, to }) {
  const body = (
    <div className="rounded-xl bg-white border border-[#0f2544]/8 p-6 hover:shadow-sm transition-shadow">
      <div className="text-3xl font-serif text-[#0f2544]">{value ?? "—"}</div>
      <div className="text-sm text-[#8a8a83] mt-1">{label}</div>
    </div>
  );
  return to ? <Link to={to} data-testid={`stat-${label}`}>{body}</Link> : <div data-testid={`stat-${label}`}>{body}</div>;
}

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { adminStats().then(setS).catch(() => {}); }, []);

  return (
    <div>
      <h1 className="font-serif text-3xl text-[#0f2544] mb-1">Dashboard</h1>
      <p className="text-[#8a8a83] mb-8">Resumen de la actividad editorial.</p>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-5">
        <StatCard label="Libros" value={s?.total_libros} to="/admin/libros" />
        <StatCard label="Autores" value={s?.total_autores} to="/admin/autores" />
        <StatCard label="Mensajes pendientes" value={s?.mensajes_pendientes} to="/admin/contactos" />
        <StatCard label="Suscriptores" value={s?.suscriptores} to="/admin/suscriptores" />
      </div>
      <StorageMeter data={s?.almacenamiento} />
      <ExternalImages data={s?.imagenes_externas} />

      <div className="mt-8">
        <div className="rounded-xl bg-white border border-[#0f2544]/8 p-6">
          <h3 className="font-serif text-xl text-[#0f2544] mb-4">Últimos contactos</h3>
          {(s?.ultimos_contactos || []).length === 0 ? (
            <p className="text-sm text-[#8a8a83]">Sin mensajes todavía.</p>
          ) : (
            <ul className="divide-y divide-[#0f2544]/6">
              {s.ultimos_contactos.map((c) => (
                <li key={c.id} className="py-3">
                  <div className="text-sm font-medium text-[#0f2544]">{c.nombre} {c.apellidos}</div>
                  <div className="text-xs text-[#8a8a83]">{c.motivo} · {c.email}</div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
